import { Dispatch, SetStateAction } from "react";

import { NotificationBulkActions } from "./NotificationBulkActions";
import { NotificationFilterButton } from "./NotificationFilterButton";
import { NotificationInboxFilterToggle } from "./NotificationInboxFilterToggle";
import { ClearableSearchInput, Row } from "@/components";

import { MIXPANEL_NOTIFICATION_SURFACES, MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { NotificationFilterState, NotificationResponse } from "@/types";

export const SelectAndFilterBar = ({
  allNotifications,
  filterState,
  filteredNotifications,
  selectedIds,
  setFilterState,
  setSelectedIds,
}: {
  allNotifications: NotificationResponse[];
  filterState: NotificationFilterState;
  filteredNotifications: NotificationResponse[];
  selectedIds: Set<number>;
  setFilterState: Dispatch<SetStateAction<NotificationFilterState>>;
  setSelectedIds: Dispatch<SetStateAction<Set<number>>>;
}) => {
  return (
    <Row className="items-center gap-3">
      <NotificationBulkActions
        notifications={filteredNotifications}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
      />
      <ClearableSearchInput
        containerClassName="min-w-0 flex-1"
        onChange={(searchQuery) => {
          setFilterState({ ...filterState, searchQuery });
        }}
        placeholder="Search notifications"
        trackingScreenName={MIXPANEL_SCREENS.NOTIFICATIONS}
        value={filterState.searchQuery}
      />
      <NotificationFilterButton
        filterState={filterState}
        setFilterState={setFilterState}
        trackingSurface={MIXPANEL_NOTIFICATION_SURFACES.PAGE}
      />
      <NotificationInboxFilterToggle
        filterState={filterState}
        notifications={allNotifications}
        setFilterState={setFilterState}
        trackingSurface={MIXPANEL_NOTIFICATION_SURFACES.PAGE}
      />
    </Row>
  );
};
